(() => {
  'use strict';
  if (customElements.get('viarte-price-follow')) return;
  class ViartePriceFollow extends HTMLElement {
    connectedCallback() {
      this._root = this.closest('product-rerender');
      this._info = this.closest('.product-info') || this._root;
      this._price = this._info?.querySelector('[data-block-type="price"] sale-price');
      const template = this.querySelector('template');
      if (!this._root || !this._price || !template) return;
      this._abort = new AbortController();
      this._panel = template.content.firstElementChild.cloneNode(true);
      this._panel.querySelector('sale-price').style.color = getComputedStyle(this._price).color;
      this._mobile = matchMedia('(max-width: 999px)');
      this._headers = [...document.querySelectorAll('.shopify-section--header, .header, x-header')];
      this._schedule = () => {
        if (!this._frame) this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          this._update();
        });
      };
      const signal = this._abort.signal;
      document.body.appendChild(this._panel);
      window.addEventListener('scroll', this._schedule, { passive: true, signal });
      window.addEventListener('resize', this._schedule, { passive: true, signal });
      this._mobile.addEventListener('change', this._schedule, { signal });
      this._resize = new ResizeObserver(this._schedule);
      this._resize.observe(this._info);
      this._headers.forEach(header => this._resize.observe(header));
      this._update();
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._resize?.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
      this._panel?.remove();
      this._panel = null;
    }
    _update() {
      if (!this._panel) return;
      if (!this._mobile.matches || !this._price.isConnected) {
        this._panel.hidden = true;
        return;
      }
      let headerBottom = 0;
      this._headers.forEach(header => {
        const r = header.getBoundingClientRect();
        const anchored = r.top <= 2 || ['fixed', 'sticky'].includes(getComputedStyle(header).position);
        if (anchored && r.top < innerHeight && r.bottom > 0) headerBottom = Math.max(headerBottom, r.bottom);
      });
      const price = this._price.getBoundingClientRect();
      const info = this._info.getBoundingClientRect();
      const top = Math.max(0, headerBottom) + 6;
      const eligible = this._price.getClientRects().length > 0 && price.top < headerBottom && info.bottom > top + 140;
      this._panel.style.top = `${top}px`;
      this._panel.style.left = `${Math.max(12, info.left)}px`;
      this._panel.style.right = `${Math.max(12, innerWidth - info.right)}px`;
      this._panel.hidden = !eligible;
    }
  }
  customElements.define('viarte-price-follow', ViartePriceFollow);
})();

